import { render, staticRenderFns } from "./FormWizard.vue?vue&type=template&id=06ee7bfe&scoped=true"
import script from "./FormWizard.vue?vue&type=script&lang=js"
export * from "./FormWizard.vue?vue&type=script&lang=js"
import style0 from "./FormWizard.vue?vue&type=style&index=0&id=06ee7bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee7bfe",
  null
  
)

export default component.exports